import { IMacroExam } from 'interfaces';
import { BaseService } from './BaseService';

class MacroExamService extends BaseService<IMacroExam> {
  constructor() {
    super('macro-exams');
  }
  canDelete = true;
}

export const macroExamService = new MacroExamService();
